import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import * as AuthActions from '../auth/auth.actions';
import { GameThemeSettingsDispatcher } from "./gameThemeSettings.dispatcher";

@Injectable()
export class GameThemeSettingsEffects {

    constructor(
        private actions$: Actions,
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher
    ) {}

    loginAction$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.authenticatedAction),
            tap((authenticated) => {
                if(authenticated.userData.uid) {
                    this.getUnlockedItems(authenticated.userData.uid);
                }
            })
        ), { dispatch: false });

    getUnlockedItems(userID: string) {
        this.gameThemeSettingsDispatcher.subscibeToThemeSettings(userID);
        this.gameThemeSettingsDispatcher.getPurchasedFelts();
        this.gameThemeSettingsDispatcher.getPurchasedBackgrounds();
        this.gameThemeSettingsDispatcher.getPurchasedCardStyles();
        this.gameThemeSettingsDispatcher.getPurchasedAvatars();
    }
}